import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    closePhrasesSelectorWizard,
    submitSelectionWizard
} from '../../actions/phrasesSelectorWizard';
import {
    PhrasesSelectorInspector,
    PhrasesSelectorInspectorProps
} from '../../components/PhrasesSelectorInspector/PhrasesSelectorInspector';
import { selectPhrasesSelectorWizard } from '../../selectors/phrasesSelectorWizard/phrasesSelectorWizard';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    isMinusWordsListEnabled: boolean;
}

export type StateProps = TStateProps<PhrasesSelectorInspectorProps, OwnProps>;

export type DispatchProps = TDispatchProps<
    PhrasesSelectorInspectorProps,
    OwnProps
>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { isVisible } = selectPhrasesSelectorWizard(state, ownProps.wizardId);
    const { clientInfo } = state.grid;

    return {
        isVisible: isVisible,
        clientInfo
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    return {
        onClosePhrasesSelectorWizard() {
            dispatch(closePhrasesSelectorWizard(ownProps.wizardId));
        },
        onSubmitPhrasesSelectorWizard() {
            dispatch(submitSelectionWizard(ownProps.wizardId));
        }
    };
};

export const PhrasesSelectorInspectorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(PhrasesSelectorInspector);
